import React, { useCallback, useContext } from 'react';
import get from 'lodash/get';
import set from 'lodash/set';

import MultiselectChips from 'src/presentation/components/forms/MultiselectChips';
import useTopics from 'src/presentation/components/pages/rules/hooks/useTopics';
import FormContext from 'src/presentation/contexts/FormContext';

const TopicsMultiSelect = ({ attr, className, disabled, prompt }) => {
  const { dataMergeFinished, topicOptions, removableOptions } = useTopics();

  const { workingState, onBlur } = useContext(FormContext);

  const values = get(workingState, attr, '')
    .split(',')
    .filter(value => value);

  const handleValuesChanged = state => {
    updateWorkingState(state);
  };

  const updateWorkingState = useCallback(
    (newState: any) => {
      onBlur && onBlur({ currentState: set({}, attr, newState.join(',')), needToOverrideState: false });
    },
    [attr, onBlur]
  );

  if (!dataMergeFinished) return null;

  return (
    <div>
      <MultiselectChips
        attr={attr}
        className={className}
        data-aid="topics-selector"
        disabled={disabled}
        label={prompt}
        onValuesChanged={handleValuesChanged}
        options={topicOptions}
        placeholder="Search inboxes"
        removableOptions={removableOptions}
        values={values}
      />
    </div>
  );
};

export default TopicsMultiSelect;
